<template>
<router-view></router-view>
</template>

<script>

export default {
    name: "SettingsPage",
}
</script>

<style scoped>

</style>